export const ASSIGNMENT_VERSION_LEGACY = 'legacy';
export const ASSIGNMENT_VERSION_MVE = 'single_asset_mve';
